export default __webpack_public_path__ + "static/webRotator/svg/572a7e2aa9e9a8d0ebe54e94a8d514c0.svg";